import React, { useState } from "react";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { BIBlue, BIGrey } from "../../assets/helpers";
import PublicIcon from "@mui/icons-material/Public";
import { useSelector } from "react-redux";
import AddWebsiteModal from "../common/AddWebsiteModal";
import WorkIcon from "@mui/icons-material/Work";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddDescriptionModal from "../common/AddDescriptionModal";
import { GoogleMap, Marker } from "@react-google-maps/api";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AddProjectTypeModal from "./AddProjectTypeModal";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";

const ProjectAboutSection = ({ projectDetails, onProjectDetailsSaveSuccessfully }) => {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const { pathname } = useLocation();
  const [basicDetailsModalType, setBasicDetailsModalType] = useState(null);

  const {
    TEXT_ABOUT_INFO = English?.ProjectAboutSection?.TEXT_ABOUT_INFO,
    TEXT_ADD_DESCRIPTION = English?.ProjectAboutSection?.TEXT_ADD_DESCRIPTION,
    BUTTON_ADD_PROJECT_TYPE = English?.ProjectAboutSection?.BUTTON_ADD_PROJECT_TYPE,
    BUTTON_ADD_WEBSITE = English?.ProjectAboutSection?.BUTTON_ADD_WEBSITE,
    TEXT_LATITUDE = English?.ProjectAboutSection?.TEXT_LATITUDE,
    TEXT_LONGITUDE = English?.ProjectAboutSection?.TEXT_LONGITUDE
  } = multiLanguageData?.ProjectAboutSection || {};

  function handleWebRedirect(inputUrl) {
    try {
      let fullUrl = new URL(inputUrl);
      let baseUrl = `${fullUrl?.hostname}`;
      window.open(`http://${baseUrl}`, "_blank");
    } catch (error) {
      window.open(`http://${inputUrl}`, "_blank");
    }
  }

  function extractBaseURL(inputUrl) {
    try {
      let fullUrl = new URL(inputUrl ?? "");
      let baseUrl = `${fullUrl?.hostname}`;
      return baseUrl ?? "";
    } catch (error) {
      return inputUrl;
    }
  }

  return (
    <>
      <Card className="pagelist-content" sx={{ p: 2 }}>
        <Typography variant="h6"> {TEXT_ABOUT_INFO}</Typography>
        <Stack  sx={{ gap: 2, mt: 1 }}>
          {(projectDetails?.description || !pathname.includes("proxySite")) && (
            <Stack>
              {projectDetails?.description ? (
                <Stack direction="row" spacing={2}>
                  <Typography variant="body1" sx={{ wordBreak: "break-all" }}>
                    {projectDetails?.description}
                  </Typography>
                </Stack>
              ) : (
                !pathname.includes("proxySite") && (
                  <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setBasicDetailsModalType("info");
                      }}
                      style={{ width: "100%" }}>
                      {TEXT_ADD_DESCRIPTION}
                    </Button>
                  </Stack>
                )
              )}
            </Stack>
          )}

          {(projectDetails?.projectTypeName || !pathname?.includes("proxySite")) && (
            <Stack>
              {projectDetails?.projectTypeName ? (
                <Stack direction="row" spacing={2}>
                  <WorkIcon color="primary" />
                  <p>{projectDetails?.projectTypeName}</p>
                </Stack>
              ) : (
                !pathname?.includes("proxySite") && (
                  <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
                    <WorkIcon color="primary" />
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setBasicDetailsModalType("projectType");
                      }}
                      style={{ width: "100%" }}>
                      {BUTTON_ADD_PROJECT_TYPE}
                    </Button>
                  </Stack>
                )
              )}
            </Stack>
          )}
          {projectDetails?.startDate && (
            <Stack direction="row" spacing={2}>
              <CalendarMonthIcon color="primary" />
              <p>
                {dayjs(projectDetails?.startDate).format("MMM YYYY")}
                {projectDetails?.endDate && (
                  <> - {dayjs(projectDetails?.endDate).format("MMM YYYY")}</>
                )}
              </p>
            </Stack>
          )}

          {(projectDetails?.projectWebsite || !pathname.includes("proxySite")) && (
            <Stack>
              {projectDetails?.projectWebsite ? (
                <Stack direction="row" spacing={2}>
                  <PublicIcon color="primary" />
                  <span
                    style={{
                      color: BIBlue,
                      cursor: "pointer",
                      textDecoration: "underline"
                    }}
                    onClick={() => handleWebRedirect(projectDetails?.projectWebsite)}>
                    {extractBaseURL(projectDetails?.projectWebsite)}
                  </span>
                </Stack>
              ) : (
                !pathname?.includes("proxySite") && (
                  <Stack direction="row" sx={{ alignItems: "center" }} spacing={2}>
                    <PublicIcon color="primary" />
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setBasicDetailsModalType("website");
                      }}
                      style={{ width: "100%" }}>
                      {BUTTON_ADD_WEBSITE}
                    </Button>
                  </Stack>
                )
              )}
            </Stack>
          )}

          <Stack direction="row" spacing={2}>
            <LocationOnIcon style={{ color: BIBlue }} />
            <Stack>
              <Typography variant="body1">{projectDetails?.siteName ?? ""}</Typography>
              <Box>
                {projectDetails?.address === "" || projectDetails?.address === null ? (
                  <Box>
                    {projectDetails?.latitude &&
                      projectDetails?.latitude != 0 &&
                      projectDetails?.longitude &&
                      projectDetails?.longitude != 0 ? (
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {`${TEXT_LATITUDE}: ${projectDetails?.latitude}, ${TEXT_LONGITUDE}: ${projectDetails?.longitude}`}
                      </Typography>
                    ) : null}
                  </Box>
                ) : (
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {projectDetails?.address.trim() + ", "}
                    {projectDetails?.city.trim() + ", "}
                    {projectDetails?.province.trim() + ", "}
                    {projectDetails?.postalCode.trim() + ", "}
                    {projectDetails?.country.trim()}
                  </Typography>
                )}
              </Box>
            </Stack>
          </Stack>

          <Card className="pagelist-content">
            <GoogleMap
              mapContainerClassName="site-map-container"
              mapContainerStyle={{
                width: "100%",
                height: "300px"
              }}
              center={{
                lat: projectDetails?.latitude ?? 0,
                lng: projectDetails?.longitude ?? 0
              }}
              zoom={13}
              options={{
                fullscreenControl: false,
                zoomControl: false,
                streetViewControl: false,
                scrollwheel: false,
                fullscreenControlOptions: false,
                mapTypeControl: false,
                styles: [
                  {
                    featureType: "poi",
                    stylers: [
                      { visibility: "off" } // Enable POIs
                    ]
                  }
                ]
              }}
              onDrag={false}>
              <Marker
                position={{
                  lat: projectDetails?.latitude ?? 0,
                  lng: projectDetails?.longitude ?? 0
                }}
                icon={{
                  url: mapMarkerYellow,
                  scaledSize: new window.google.maps.Size(30, 40)
                }}
              />
            </GoogleMap>
          </Card>
        </Stack>
      </Card>

      {basicDetailsModalType === "website" && (
        <AddWebsiteModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="project"
          data={projectDetails}
          onDataSave={onProjectDetailsSaveSuccessfully}
          onSaveClick={() => { }}
        />
      )}

      {basicDetailsModalType === "info" && (
        <AddDescriptionModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="project"
          data={projectDetails}
          onDataSave={onProjectDetailsSaveSuccessfully}
        />
      )}

      {basicDetailsModalType === "projectType" && (
        <AddProjectTypeModal
          open={true}
          onClose={() => {
            setBasicDetailsModalType(null);
          }}
          from="productProfile"
          projectDetails={projectDetails}
          onDataSave={onProjectDetailsSaveSuccessfully}
        />
      )}
    </>
  );
};

export default ProjectAboutSection;
